import MakeShorter from "./make-shorter.svelte";

const root = document.querySelector("#app-make-shorter");

if (root) {
  const target = root.attachShadow({ mode: "open" });
  new MakeShorter({ target });
} else {
  console.error("Demo container not found.");
}
